import { MobileNavigation } from './MobileNavigation';
import { DesktopNavigation } from './DesktopNavigation';
import { HeaderBrand } from './HeaderBrand';
import { MessageCircle } from 'lucide-react';
import { Button } from '../ui/button';
import { useSectionNavigation } from '../../hooks/useSectionNavigation';

export const SiteHeader = ({ handleWhatsAppClick }) => {
  const { isMenuOpen, setIsMenuOpen, scrollToSection } = useSectionNavigation();
  return (
<header data-testid="site-header" onKeyDown={(event) => { if (event.key === 'Escape') setIsMenuOpen(false); }} className="site-header fixed top-0 w-full z-50 bg-black/98 backdrop-blur-md border-b border-red-900/40 shadow-lg shadow-red-900/20">
        <nav className="container mx-auto px-4 py-4">
          <div className="flex items-center justify-between">
            <HeaderBrand />
            
            <DesktopNavigation scrollToSection={scrollToSection} />

            <Button 
              data-testid="header-whatsapp-button"
              onClick={handleWhatsAppClick}
              className="hidden lg:flex items-center space-x-2 bg-gradient-to-r from-green-500 to-green-600 hover:from-green-600 hover:to-green-700 text-white transition-all duration-300 shadow-lg shadow-green-500/30 font-semibold"
              size="lg"
            >
              <MessageCircle className="w-5 h-5" />
              <span>WhatsApp</span>
            </Button>

            <button 
              data-testid="mobile-menu-toggle"
              aria-label={isMenuOpen ? 'Fermer le menu' : 'Ouvrir le menu'}
              aria-expanded={isMenuOpen}
              aria-controls="mobile-navigation"
              className="lg:hidden text-white"
              onClick={() => setIsMenuOpen(open => !open)}
            >
              <div className="w-6 h-0.5 bg-white mb-1.5"></div>
              <div className="w-6 h-0.5 bg-white mb-1.5"></div>
              <div className="w-6 h-0.5 bg-white"></div>
            </button>
          </div>

          {isMenuOpen && (
            <MobileNavigation scrollToSection={scrollToSection} handleWhatsAppClick={handleWhatsAppClick} />
          )}
        </nav>
      </header>
  );
};
